var publicPath = __webpack_public_path__;
                    var symbolUrl = 'sprites.b21c854ce00ee6ee1fcc4040ae854c08.svg#f';
                    var viewUrl = 'sprites.b21c854ce00ee6ee1fcc4040ae854c08.svg#view-f';

                    

                    module.exports = {
                        url: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 32 32',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };